import { render, staticRenderFns } from "./empresasmantenedoras.vue?vue&type=template&id=bf4930cc"
import script from "./empresasmantenedoras.vue?vue&type=script&lang=js"
export * from "./empresasmantenedoras.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports